import { useEffect, useRef, useState } from "react";

export default function LazyImage({ src, alt }) {
    const ref = useRef(null);
    const [load, setLoad] = useState(false);

    useEffect(() => {
        if (!ref.current) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setLoad(true);
                    observer.disconnect();
                }
            },
            { rootMargin: "300px" }
        );

        observer.observe(ref.current);
        return () => observer.disconnect();
    }, []);

    return (
        <div
            ref={ref}
            style={{
                minWidth: 90,
                minHeight: 160,
                flexShrink: 0,
            }}
        >
            {load && (
                <img
                    src={src}
                    alt={alt}
                    loading="lazy"
                    decoding="async"
                    style={{ height: 60, width: "auto" }}
                />
            )}
        </div>
    );
}
